'use client';

import { useEffect, useState } from 'react';

export const useHeaderHeight = (): number | null => {
  const [headerHeight, setHeaderHeight] = useState<number | null>(null);

  useEffect(() => {
    const updateHeaderHeight = () => {
      // CSS-переменная библиотеки задаёт высоту в пикселях.
      const value = window
        .getComputedStyle(document.documentElement)
        .getPropertyValue('--external-header-height');
      const height = Number.parseFloat(value);
      setHeaderHeight(Number.isFinite(height) ? height : 0);
    };

    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);

    return () => window.removeEventListener('resize', updateHeaderHeight);
  }, []);

  return headerHeight;
};
